import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import HostRouter from './routes/main-router';
import { AuthProvider } from './context/auth/auth-context';

function App() {
  // useEffect(() => {
  //   // **Auto Reset Zoom Function**
  //   const resetZoom = () => {
  //     (document.body.style as any).zoom = "100%";
  //     (document.documentElement.style as any).zoom = "100%";

  //     // Handle visualViewport safely
  //     if (window.visualViewport) {
  //       const scale = window.visualViewport.scale || 1;
  //       if (scale !== 1) {
  //         document.body.style.transform = `scale(${1 / scale})`;
  //         document.body.style.transformOrigin = "top left";
  //         document.body.style.width = `${100 * scale}%`;
  //       }
  //     }
  //     // document.body.style.transform = 'scale(1)';
  //     // document.body.style.transformOrigin = 'top left';
  //   };

  //   resetZoom(); // Reset zoom on component mount

  //   // **Prevent Zooming**
  //   const preventZoom = (event: WheelEvent) => {
  //     if (event.ctrlKey || event.metaKey) {
  //       event.preventDefault();
  //       resetZoom(); // Auto-reset if user tries to zoom
  //     }
  //   };

  //   const preventKeyZoom = (event: KeyboardEvent) => {
  //     if ((event.ctrlKey || event.metaKey) && (event.key === '=' || event.key === '-' || event.key === '0' || event.key === '+')) {
  //       event.preventDefault();
  //       resetZoom(); // Auto-reset if zoom keys are pressed
  //     }
  //   };

  //   const preventTouchZoom = (event: TouchEvent) => {
  //     if (event.touches.length > 1) {
  //       event.preventDefault();
  //       resetZoom(); // Auto-reset on pinch zoom
  //     }
  //   };

  //   window.addEventListener('resize', resetZoom); // Reset zoom on window resize
  //   document.addEventListener('wheel', preventZoom, { passive: false });
  //   document.addEventListener('keydown', preventKeyZoom);
  //   document.addEventListener('touchstart', preventTouchZoom, { passive: false });

  //   return () => {
  //     window.removeEventListener('resize', resetZoom);
  //     document.removeEventListener('wheel', preventZoom);
  //     document.removeEventListener('keydown', preventKeyZoom);
  //     document.removeEventListener('touchstart', preventTouchZoom);
  //   };
  // }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <HostRouter />
      </AuthProvider>
      <ToastContainer style={{ zIndex: 999999 }} />
    </BrowserRouter>
  );
}

export default App;